import React, { memo, useState, useEffect } from "react";
import { InputLabel, FormControl, FormHelperText, Grid } from "@mui/material";
import useStyles from "./styles";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./customStyle.css";

interface IPhoneInputField {
  id?: string;
  label?: string;
  required?: boolean;
  value?: any;
  onChange?: any;
  testId?: any;
  errorMessage?: string;
  isTouched?: boolean;
}

const PhoneInputField = ({
  id,
  value,
  label,
  required = false,
  onChange,
  testId,
  errorMessage,
  isTouched,
}: IPhoneInputField) => {
  const classes = useStyles();
  const isErrorOccurs = isTouched && errorMessage;

  const [isDropdownFlipped, setIsDropdownFlipped] = useState(false);

  const checkDropdownPosition = () => {
    const countryListElement = document.querySelector(".country-list");
    const phoneInputElement = document.querySelector(
      ".react-tel-input-container input",
    );

    if (phoneInputElement && countryListElement) {
      const inputRect = phoneInputElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - inputRect.bottom;
      const dropdownHeight = countryListElement.clientHeight;

      // if there's not enough space below, flip it to the top
      if (spaceBelow < dropdownHeight) {
        setIsDropdownFlipped(true);
      } else {
        setIsDropdownFlipped(false);
      }
    }
  };

  // use MutationObserver to detect when the dropdown is rendered
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const countryListElement = document.querySelector(".country-list");
      if (countryListElement) {
        checkDropdownPosition();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <FormControl className={classes.formControl}>
      <InputLabel
        required={required}
        className={classes.inputLabel}
        shrink
        htmlFor={id}
      >
        {label}
      </InputLabel>
      <PhoneInput
        country={"jp"}
        value={value}
        onChange={onChange}
        enableSearch={true}
        placeholder="819012345678"
        countryCodeEditable={false}
        containerClass="react-tel-input-container"
        inputProps={{
          "data-testid": "phone-input-field",
          autoFocus: true,
        }}
        enableLongNumbers={true}
        dropdownClass={isDropdownFlipped ? "show-on-top" : ""}
      />
      {isErrorOccurs && (
        <Grid container>
          <FormHelperText data-testid={`errors-${id}`} className={classes.errorSpan}>
            {errorMessage}
          </FormHelperText>
        </Grid>
      )}
    </FormControl>
  );
};

PhoneInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(PhoneInputField);
